module.exports = __webpack_public_path__ + "static/Franken2-scaled-6104edd0204249f0ad81a25e56a8a4cf.jpeg";